import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const StepNav = ({ steps, step }) => {
	const items = [];
	steps.forEach((stepName, index) => {
		if (index) {
			const className = classnames({
				arrowHolder: true,
				current: index === step,
				previous: index === step + 1
			});
			items.push(
				<li key={`${index}-before`} className={className}>
					<span className="arrow arrowLeft"></span>
					<span className="arrow arrowTopRight"></span>
					<span className="arrow arrowBottomRight"></span>
				</li>
			);
		}
		const className = classnames({
			navItem: true,
			current: index === step,
			first: index === 0,
			last: index === steps.length - 1
		});
		items.push(
			<li key={index} className={className}>{stepName}</li>
		);
	});

	return (
		<nav className="stepNav">
			<ol className="stepNavList">{items}</ol>
		</nav>
	);
};

StepNav.propTypes = {
	steps: PropTypes.array,
	step: PropTypes.number
};

export default StepNav;
